import moment from 'moment'

domainList.$inject = ['filterFilter', 'orderByFilter', 'domainFlags']

export default function domainList(filterFilter, orderByFilter, domainFlags) {
  return {
    restrict: 'EA',
    scope: {
      domains: '=domainList',
      loading: '=',
      lastFetched: '=lastUpdated'
    },
    link: function(scope, elm, attrs) {
      scope.search = ''
      scope.orderKey = 'name'
      scope.reverse = false
      scope.domainFlags = domainFlags

      scope.sort = function(key) {
        if (scope.orderKey === key) {
          scope.reverse = !scope.reverse
        } else {
          scope.reverse = false
        }
        scope.orderKey = key
      }

      scope.$watchCollection('domains', function() {
        refreshResults()
      })
      scope.$watch('lastFetched', function() {
        scope.timeAgo = moment(scope.lastFetched).fromNow()
      })
      scope.$watch('search', function(search) {
        refreshResults()
      })
      scope.$watch('orderKey', function(key) {
        refreshResults()
      })
      scope.$watch('reverse', function(rev) {
        refreshResults()
      })

      function refreshResults() {
        scope.filteredDomains = filterFilter(scope.domains, scope.search)
        scope.filteredDomains = orderByFilter(scope.filteredDomains, scope.orderKey, scope.reverse)
        scope.filteredDomains.forEach(function(d) {
          var flags =
            (d.flags &&
              d.flags.map(function(f) {
                return domainFlags[f]
              })) ||
            []
          d.flags_str = (flags && flags.join(', ')) || ''
        })
      }
    },
    template: require('./_domainTable.html')
  }
}
